// eslint-disable-next-line no-unused-vars
const style = require('./src/components/css/themes.css');
require('./src/styles/marketing-typography.scss');
const { scheduleFontLoad } = require('./src/services/fonts/loadFonts');
const {
  APP_LANGUAGES,
  AUTO_LOCALE_ROUTE_KEY,
  resolveBrowserAppLanguage
} = require('./src/services/localeContract');

const slashlessWebAppRoutes = new Set([
  '/flight',
  '/auth/magic-link',
  '/auth/sign-in',
  '/auth/consent',
  '/auth/complete',
  '/flight_compensations',
  '/friends/invite',
  '/welcomepickups',
  '/cancel-survey'
]);

const normalizeWebAppRoute = () => {
  const { pathname, search, hash } = window.location;
  const flightAlias = pathname.match(/^\/([^/]+)\/flight\/?$/);
  if (flightAlias && APP_LANGUAGES.includes(flightAlias[1])) {
    window.history.replaceState(window.history.state, '', `/flight${search}${hash}`);
    return;
  }
  const normalizedPathname = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  if (pathname === normalizedPathname || !slashlessWebAppRoutes.has(normalizedPathname)) {
    return;
  }

  window.history.replaceState(window.history.state, '', `${normalizedPathname}${search}${hash}`);
};

exports.shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  // If navigating to a new page (not just hash change), scroll to top
  if (prevRouterProps && location.pathname !== prevRouterProps.location.pathname) {
    window.scrollTo(0, 0);
    return false;
  }
  // For hash links, let the browser handle it
  if (location.hash) {
    return location.hash;
  }
  return true;
};

exports.onClientEntry = () => {
  if (typeof window === 'undefined') {
    return;
  }

  normalizeWebAppRoute();

  const pathname = window.location.pathname;

  const strippedPath = pathname.replace(/^\/(?:[a-z]{2}(?:-[A-Za-z]+)?)\//, '/');
  const marketingPaths = [
    '/',
    '/airlines/',
    '/airports/',
    '/faq/',
    '/mcp/',
    '/compensation/',
    '/cancel-survey/'
  ];
  const isMarketingPage =
    marketingPaths.includes(strippedPath) ||
    strippedPath.startsWith('/features/') ||
    strippedPath.startsWith('/airline/') ||
    strippedPath.startsWith('/airlines/') ||
    strippedPath.startsWith('/airport/') ||
    strippedPath.startsWith('/compare/');
  const isFlightDetailsPage = /^\/flight\/?$/.test(strippedPath);
  const isReportPage =
    window.location.pathname.includes('/flight_feedback/') ||
    window.location.pathname.includes('/airport_report/') ||
    window.location.pathname.includes('/flight_report/') ||
    window.location.pathname.includes('/app_report/');
  if (isMarketingPage || isFlightDetailsPage) {
    scheduleFontLoad();
  }
  // Flight UI negotiates language without changing its universal share URL.
  if (isFlightDetailsPage) return;

  if (!isMarketingPage && !isFlightDetailsPage && !isReportPage) return;

  const marketingLangs = [
    'es',
    'de',
    'fr',
    'it',
    'pt-BR',
    'pt-PT',
    'cs',
    'fi',
    'hi',
    'ja',
    'ko',
    'pl',
    'ru',
    'sv',
    'th',
    'tr',
    'vi',
    'zh-Hans',
    'zh-Hant'
  ];
  const reportLangs = ['es', 'de', 'fr', 'ja', 'ko', 'ru'];
  const langs = isMarketingPage ? marketingLangs : reportLangs;

  const detectedLang = resolveBrowserAppLanguage([navigator.language], langs);

  // Check if the URL already has a language prefix
  let isLangLink = false;
  for (const lang of langs) {
    if (window.location.pathname.startsWith(`/${lang}/`)) {
      isLangLink = true;
      break;
    }
  }

  // Only auto-redirect on non-prefixed URLs (e.g., / or /faq/)
  // If user explicitly navigated to a language URL (e.g., /de/), keep them there
  if (!isLangLink && detectedLang && detectedLang !== 'en') {
    const path = `/${detectedLang}${window.location.pathname}`;
    try {
      window.sessionStorage.setItem(
        AUTO_LOCALE_ROUTE_KEY,
        JSON.stringify({ path, systemLocale: navigator.language })
      );
    } catch {
      // Locale matching must also work with storage disabled.
    }
    window.location.pathname = path;
  }
};

exports.onRouteUpdate = () => {
  normalizeWebAppRoute();
};
